<template>
  <Link
    :href="href"
    :class="classes"
  >
    <slot />
  </Link>
</template>

<script>
import {defineComponent} from 'vue';
import {Link} from '@inertiajs/vue3';

export default defineComponent({
  components: {
    Link,
  },
  props: ['href', 'active'],

  computed: {
    classes() {
      return this.active
        ? 'block px-3 py-2 text-base font-medium text-indigo-900 bg-indigo-50 rounded-md'
        : 'block px-3 py-2 text-base font-medium text-indigo-900 hover:bg-indigo-50 hover:rounded-md';
    },
  },
});
</script>
